
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
Die <Link href='https://www.who.int/news-room/detail/23-01-2020-statement-on-the-meeting-of-the-international-health-regulations-(2005)-emergency-committee-regarding-the-outbreak-of-novel-coronavirus-(2019-ncov)' allowWordWrap mdxType="Link">WHO</Link>{' '}
schätzte den R0-Wert beim neuen Coronavirus in einer ersten Prognose auf 1,4 bis 2,5. Wissenschaftler des <Link href='https://www.imperial.ac.uk/media/imperial-college/medicine/sph/ide/gida-fellowships/Imperial-2019-nCoV-transmissibility.pdf' allowWordWrap mdxType="Link">Imperial College London</Link>{' '}
kamen auf 2,6, ein <Link href='https://www.medrxiv.org/content/10.1101/2020.01.23.20018549v2.full.pdf ' mdxType="Link">amerikanisch-britisches Team</Link> auf 3,11 und Forscher der <Link href='https://www.biorxiv.org/content/10.1101/2020.01.23.916395v1' allowWordWrap mdxType="Link">University of Hongkong</Link> sogar auf 3,3 bis 5,47.
    </p><p>
Die Schätzungen reichen also von 1,4 bis 5,47. Der R0-Wert ist nicht einfach zu berechnen, speziell in einer frühen Phase einer Epidemie. Wahrscheinlich ist aber, dass er etwa bei 2,2 liegt, wie es 
der Schweizer Epidemiologe Christian Althaus der Universität Bern vermutet. <Link href='https://www.eurosurveillance.org/content/10.2807/1560-7917.ES.2020.25.4.2000058' mdxType="Link">Seine Studie</Link>{' '}
deckt sich mit den Resultaten 
zweier Erhebungen aus China, die im <Link href='https://www.nejm.org/doi/full/10.1056/NEJMoa2001316?query=featured_home' mdxType="Link">Januar</Link> und Ende <Link href=' https://www.ijidonline.com/article/S1201-9712(20)30091-6/fulltext ' mdxType="Link">Februar</Link>{' '}
veröffentlicht wurden. Damit wäre das neue Coronavirus (Sars-CoV-2) etwa gleich ansteckend wie Sars oder die Spanische Grippe vor hundert Jahren – und deutlich ansteckender als die saisonale Grippe mit einem <Link href='https://www.pnas.org/content/112/9/2723' mdxType="Link">R0-Wert von 1,3 bis 2</Link>.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;